import { useState } from "react";
import { Clock, Loader2, MessageCircleQuestion } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import api, { errorText } from "../lib/api";

// "Ask us to review it" ($0): the duck waits for owner/staff; a paid change of the duck cancels the request.
export const AskReviewButton = ({ creation, onUpdate, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const asked = creation.view_check?.review;
  if (asked) {
    return (
      <div data-testid="hold-waiting-review" className={`rounded-2xl border border-accent/40 bg-accent/10 px-4 py-3 text-sm ${className}`}>
        <p className="font-semibold flex items-center gap-2">
          <Clock className="h-4 w-4 text-accent" /> Waiting for review
        </p>
        <p className="text-muted-foreground mt-1">
          We have been told and will take a look. You can still change the duck yourself, but that cancels this request.
        </p>
      </div>
    );
  }
  const ask = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/creations/${creation.id}/view-check/review`);
      onUpdate(data);
      toast.success("Thanks, we'll review it. You'll find it here, waiting for review.");
    } catch (e) {
      toast.error(errorText(e, "Could not send the review request. Please try again."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button data-testid="hold-ask-review-btn" variant="outline" disabled={busy} onClick={ask} className={`rounded-full h-11 gap-2 ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <MessageCircleQuestion className="h-4 w-4" />} Ask us to review it · free
    </Button>
  );
};
